import React from 'react';
import BlogCard from '../Blog/BlogCard';
import PostCarousel from '../shared/PostCarousel/PostCarousel';
import { blogPosts } from '../../content/blog';

/** Homepage teaser: the newest blog posts in the shared PostCarousel. */
const HomeBlogSection = () => {
  const latestPosts = blogPosts.slice(0, 5);

  return (
    <PostCarousel
      items={latestPosts}
      itemKey={(post) => post.slug}
      renderItem={(post) => <BlogCard post={post} />}
      title="Einblicke aus der Praxis"
      subtitle="Aktuelle Beiträge rund um Web, Apps und digitales Wachstum."
      viewAllTo="/blog"
      viewAllLabel="Alle Beiträge →"
      ariaLabel="Blogbeiträge"
    />
  );
};

export default HomeBlogSection;
